// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-6777cbdd]{margin-top:5rem}.header__container[data-v-6777cbdd]{max-width:49.375rem}@media only screen and (min-width:960px){.header__container[data-v-6777cbdd]{padding:0!important}}@media only screen and (min-width:1264px){.header__description[data-v-6777cbdd]{font-size:1.5rem;line-height:1.33}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
